import { ISectionItemResponse } from "./section-item-response";

export enum SectionType {
    FreeText = 1,
    ItemList = 2,
    ImageGallery = 3,
    AccordionFaq = 4,
    MixedContent = 5,
    VideoEmbed = 6
}

export interface IPageSectionResponse {
    id: number;
    pageId: number;
    type: SectionType;
    typeName?: string;
    title?: string;
    content?: string;
    url?: string;
    imageFileName?: string;
    imageUrl?: string;
    order: number;
    items?: ISectionItemResponse[];
}
